import styled from "styled-components";
// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: `${theme.spacing.xLarge} 0 ${theme.spacing.large} 0`,
    };
});

export const ImageContainer = styled.div<{ height?: number; width?: number }>(({ height, width }) => {
    return {
        width: width ? `${width}px` : "60px",
        height: height ? `${height}px` : "35px",
    };
});

export const StyledText = styled(Text)(({ theme }) => {
    return {
        marginTop: `calc(${theme.spacing.medium} * -1)`,
        whiteSpace: "pre-wrap",
    };
});
